// Per-location image gallery convention.
//
// Files live at web/public/images/locations/{slug}/{n}.webp where n
// runs from 1 to imageCount. Image #1 is the hero and the og:image.
// `imageCount` comes from the DB (locations.image_count) → API
// → catalog snapshot, so the frontend never reads the filesystem.

const BASE = '/images/locations';

export function locationImagePath(slug: string, n: number): string {
  return `${BASE}/${slug}/${n}.webp`;
}

// Ordered list of all gallery image URLs for a venue. Empty when the
// venue has no images yet (callers should render their placeholder).
export function locationImages(slug: string, imageCount: number): string[] {
  if (!imageCount || imageCount < 1) return [];
  return Array.from({ length: imageCount }, (_, i) =>
    locationImagePath(slug, i + 1),
  );
}

// The single hero image (image #1) or null if none.
export function locationHero(
  slug: string,
  imageCount: number,
): string | null {
  return imageCount > 0 ? locationImagePath(slug, 1) : null;
}

// Absolute URL of the hero image (for og:image meta tags). Returns
// null when the venue has no images.
export function locationHeroAbsolute(
  slug: string,
  imageCount: number,
  origin: string,
): string | null {
  const path = locationHero(slug, imageCount);
  return path ? `${origin}${path}` : null;
}
